import { render, staticRenderFns } from "./handel.vue?vue&type=template&id=2dbd0ae4"
import script from "./handel.vue?vue&type=script&lang=js"
export * from "./handel.vue?vue&type=script&lang=js"
import style0 from "./handel.vue?vue&type=style&index=0&id=2dbd0ae4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports